export default __webpack_public_path__ + "static/media/arrow_right-black.eb8fd3a5.svg";